import {  isEmpty, isFormValid, setError, syncProfileMarker } from '../../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { applyOutcomeLogic } from '../../../../library/Service/outcomeStatusByCurrentYear';
import  { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';
import { isValidIsCurrentAsPerWorkingStatus } from '../professional-work/ProfessionalWorkActions';
import { primaryErrorKeysToIgnore, validateOnePrimaryCurrent } from '../primaryCurrentJob';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();
    console.log("state?.data?.currentMatch",state?.data?.currentMatch)

    const inValidDate = isValidDate(state, dispatch);
    const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';
    const customValidationPassed = isFormValidBasedOnCustomValidation(state, dispatch);

    if (!isImpersonatedSession && (!customValidationPassed || !inValidDate || !isFormValid(state, dispatch, primaryErrorKeysToIgnore(state, 'teachingWork')))) {
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }

    const { teachingWork = [], jobsList = [], jobsApplied = [], profile } = state.data;
    let updatedTeachingWork = teachingWork.map((job:any) => {
        const existingJob = jobsList.find((existingJob: any) => existingJob.id === job.id);
        return updateJobRecord(job, existingJob);
    });

    const jobsNotInTeachingWork = jobsList.filter((existingJob: any) => !teachingWork.some((job: any) => job.id === existingJob.id));
    updatedTeachingWork = [...updatedTeachingWork, ...jobsNotInTeachingWork];

    let jobHistory = [...updatedTeachingWork, ...jobsApplied];

    jobHistory = jobHistory.map((job: any) => ({
        ...job,
        countryCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCountryCode : job.countryCode)?.trim() || null,
        cityCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCityCode : job.cityCode)?.trim() || null
    }));
    
    //For checking is_current as per WorkingStatus
    const isValidIsCurrent = isValidIsCurrentAsPerWorkingStatus('teachingWork',jobHistory,state, dispatch);
    if (!isValidIsCurrent) {
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }

    let updatedJobs = jobHistory;
    let updatedSelectedInstitute = state.data.selectedInstitute;
    let updatedUserInstitutes = state.data.userInstitutes;
    if (isEmpty(updatedSelectedInstitute?.postProgramCompletionStatusCode)) {
        const result = applyOutcomeLogic(jobHistory, updatedSelectedInstitute, "TEACHING_AND_RESEARCH",updatedUserInstitutes);
        updatedJobs = result.updatedJobs;
        updatedSelectedInstitute = result.updatedSelectedInstitute;
        updatedUserInstitutes = result.updatedUserInstitutes;

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {
                    ...state.data,
                    teachingWork: updatedJobs.filter(
                        j => j.jobCategory === 'TEACHING_AND_RESEARCH'
                    ),
                    selectedInstitute: updatedSelectedInstitute,
                    userInstitutes: updatedUserInstitutes,
                },
            },
        });
    }
    
    // Send event to Moengage PG College (optional, if needed)
    // sendMoEngageEvent(state.data);
    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({
            id: state.routeInfo.id,
            jobs: updatedJobs,
            profile,
            userInstitutes: updatedUserInstitutes,
            selectedInstitute: updatedSelectedInstitute   //update for year logic -> current as outcome < 2
     })
    ).then((response) => {
        if (response?.status === 200) {
            syncProfileMarker(state.routeInfo.id).then(() => {
                navigateToNextStep(AlumniProfileEditScreens.WORK_DETAILS,
                    {
                        ...state,
                        data: {
                            ...state.data,
                            selectedInstitute: updatedSelectedInstitute,
                            userInstitutes: updatedUserInstitutes,
                            jobs: updatedJobs
                        }
                    },
                    dispatch, sessionState, sessionDispatch);
            });
        }
    });
};

const updateJobRecord = (job: any, existingJob?: any) => {
    const updatedJob = {
        ...existingJob,
        ...job,
        recordTypeCode: existingJob?.recordTypeCode || job.recordTypeCode || 'JOINED',
        jobCategory: 'TEACHING_AND_RESEARCH',
        industryCode: 7,
        functionalAreaCode: 6,
        isPrimaryCurrent: job.isCurrent ? Boolean(job.isPrimaryCurrent) : false,
    };
    if (job.isCurrent) {
        updatedJob.endDate = null;
    }
    return updatedJob;
};

const isFormValidBasedOnCustomValidation = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const errorMessages = [] as any[];
    let isFormInvalid = false;
    const jobs = state.data.jobsApplied;
    const teachingWork = state.data.teachingWork;

    teachingWork.forEach((teachingWork: any, index: number) => {
        if (isEmpty(teachingWork?.instituteId) && isEmpty(teachingWork?.otherInstitute)) {
            isFormInvalid = true;
            setError(`teachingWork.${index}.instituteId`, [`Please enter "Name of Institution"`], dispatch);
        } else {
            setError(`teachingWork.${index}.instituteId`, [], dispatch);
        }
    });

    // Dispatch the validation errors to the state
    if (isFormInvalid) {
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'teachingWork', errorMessages },
        });
    }
    if (!validateOnePrimaryCurrent(state, dispatch, 'teachingWork')) isFormInvalid = true;
    return !isFormInvalid;
};

export const onCurrentJobSelectionChange = (props: ControlOnChangeArguments) => {
    const rowIndex = parseInt(props.parentDataKey.split('.').pop() as string);
    const jobs = props.state.data.teachingWork.map((row: any, index: number) => {
        setError(`teachingWork.${index}.endDate`, [], props.dispatch);
        return index == rowIndex ? { ...row, endYear: '', isCurrent: false } : { ...row, isCurrent: false };
    });
    props.dispatch({ type: 'SET_FIELD_VALIDATION_ERRORS', payload: { dataKey: `${props.parentDataKey}.jobStartAndEndDates`, value: [] } });

    props.dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey: 'teachingWork', value: jobs } });
};


// export const onStartDateChange = (props: ControlOnChangeArguments) => {
//     console.log("state?.data?.teachingWork",props.state?.data?.teachingWork)
//     const { updatedJobs, updatedUserInstitutes } = applyOutcomeLogic(
//         props.state?.data?.teachingWork,
//         props.state?.data?.selectedInstitute?.passOutYear,
//         props.state?.data?.userInstitutes,
//         "TEACHING_AND_RESEARCH"
//     );

//     console.log("updatedUserInstitutes",updatedUserInstitutes)

//     props.dispatch({
//         type: 'REFRESH_DATA',
//         payload: {
//             data: {
//                 ...props.state.data,
//                 teachingWork: updatedJobs,
//                 userInstitutes: updatedUserInstitutes,
//                 selectedInstitute: updatedUserInstitutes?.find(
//                     (inst) => inst.instituteId === props.state.data.selectedInstitute?.instituteId
//                 ),
//             },
//         },
//     });
// };

export const onEndDateChange = (props: ControlOnChangeArguments) => {
    const errorMessages =
        new Date(props.value) < new Date(props.row.startDate) ? ['End year should be greater than or equal to Start year'] : [];
    props.errorMessages.push(errorMessages);
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
    // state.actions['ROUTER_NAVIGATE']('/alumni/dashboard');
    //ScreenNavigationService.navigateToNextStep(AlumniProfileEditScreens.WORK_DETAILS, state, dispatch);
};

const isValidDate = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const teachingWorkdata = state?.data['teachingWork'];
    let isFormValid = true;
    teachingWorkdata.forEach((teachingjob: any, index: number) => {
        console.log(teachingjob);

        if (isEmpty(teachingjob?.startDate)) {
            setError(`teachingWork.${index}.startDate`, [`Please enter "Start Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`teachingWork.${index}.startDate`, [], dispatch);
        }

        if ((teachingjob?.isCurrent === false || isEmpty(teachingjob?.isCurrent)) && isEmpty(teachingjob?.endDate)) {
            setError(`teachingWork.${index}.endDate`, [`Please enter "End Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`teachingWork.${index}.endDate`, [], dispatch);
        }

        if (new Date(teachingjob?.startDate) >= new Date(teachingjob?.endDate)) {
            console.log('Invalid date');
        }

        if (teachingjob?.isCurrent === false || isEmpty(teachingjob?.isCurrent)) {
            if (isEmpty(teachingjob?.endDate) || new Date(teachingjob?.startDate) > new Date(teachingjob?.endDate)) {
                setError(`teachingWork.${index}.endDate`, [`End year should be greater than or equal to Start year`], dispatch);
                isFormValid = false;
            } else {
                setError(`teachingWork.${index}.endDate`, [], dispatch);
            }
        }
    });

    return isFormValid;
};
